<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <card>
        <div
          class="col-md-12 col-lg-12 col-sm-12"
          role="dialog"
          aria-labelledby="modalTitle"
          aria-describedby="modalDescription"
        >
          <div class="modal-body">
            <div>
              <h4
                slot="header"
                id="modalTitle"
                class="card-title mb-3 text-align-center"
              >
                {{ `${titulo} Responsável` }}
              </h4>
              <form id="modalDescription">
                <div class="row">
                  <div class="col-md-12">
                    <base-input
                      type="text"
                      label="Nome*"
                      max="40"
                      placeholder="Nome"
                      v-model="responsavel.nome"
                      @input="validaCampos()"
                      @change="validaCampos()"
                    ></base-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <label for="perfil">Estado*</label>
                    <select
                      v-model="responsavel.estado"
                      class="form-control"
                      @change="validaCampos()"
                    >
                      <option
                        v-for="estado in [{ value: '', label: '' }, ...estados]"
                        :value="estado.value"
                        :label="estado.label"
                        :key="estado.label"
                      ></option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <base-input
                      type="email"
                      label="Email*"
                      placeholder="Email"
                      v-model="responsavel.email"
                    ></base-input>
                  </div>
                  <div class="col-md-4">
                    <base-input
                      type="tel"
                      label="Telefone"
                      placeholder="Telefone*"
                      v-model="responsavel.telefone"
                      maxlength="14"
                    ></base-input>
                  </div>
                </div>

                <div class="row mb-4" v-if="action === 'NEW'">
                  <base-checkbox
                    v-model="responsavel.ativo"
                    class="d-flex align-items-center"
                  />
                  <label for="ativo" class="mb-0 d-flex align-items-center"
                    >Ativar ao cadastrar</label
                  >
                </div>

                <div class="row pl-3 align-items-center">
                  <button
                    id="upload_widget"
                    class="d-inline"
                    @click.prevent="uploadImage()"
                    v-if="!(this.responsavel && this.responsavel.imagem)"
                  >
                    Selecionar imagem
                  </button>
                  <div
                    class="d-inline align-self-center"
                    v-if="this.responsavel && this.responsavel.imagem"
                  >
                    <img
                      :src="responsavel.imagem"
                      alt="Foto do perfil"
                      id="profile-photo"
                    />
                    <button
                      class="btn btn-icon btn-danger ml-2"
                      @click.prevent="deleteImage"
                    >
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </div>
                </div>
                <div class="text-center mt-4">
                  <button
                    :disabled="invalidForm"
                    type="submit"
                    class="btn btn-success btn-fill float-right"
                    @click.prevent
                    @click="salvarUsuario"
                  >
                    <i class="fa fa-floppy-o" aria-hidden="true"></i> Salvar
                  </button>
                  <button
                    @click.prevent
                    class="btn btn-danger btn-fill float-left"
                    @click="close"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i> Fechar
                  </button>
                </div>
                <div class="clearfix"></div>
              </form>
            </div>
          </div>
        </div>
      </card>
    </div>
  </transition>
</template>

<script>
import Card from 'src/components/Cards/Card.vue';
import ResponsavelService from 'src/services/responsavelEstado';
import { validateEmail, estadosBr } from '../../utils';

import _ from 'lodash';

export default {
  components: {
    Card
  },
  props: {
    action: String,
    afterCreateAction: Function,
    responsavel: {
      id: '',
      imagem: '',
      nome: '',
      email: '',
      estado: '',
      ativo: false
    }
  },
  data() {
    return {
      loadingConfig: {
        // Pass props by their camelCased names
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourMethodName,
        color: '#000000',
        loader: 'spinner',
        width: 64,
        height: 64,
        backgroundColor: '#ffffff',
        opacity: 0.5,
        zIndex: 999
      },
      notifications: {
        topCenter: false
      },
      erro: {
        nome: false,
        email: false,
        telefone: false
      },
      simple: '',
      name: 'modal',
      estados: estadosBr,
      hasImage: false
    };
  },
  computed: {
    titulo() {
      if (this.action === 'EDIT') {
        return 'Editar';
      } else if (this.action === 'NEW') {
        return 'Cadastrar';
      }
    },
    invalidForm() {
      return (
        this.responsavel.nome === '' ||
        this.responsavel.email === '' ||
        (this.responsavel.email !== '' &&
          !validateEmail(this.responsavel.email)) ||
        this.responsavel.telefone === '' ||
        (this.responsavel.telefone !== '' &&
          this.responsavel.telefone.length !== 14) ||
        this.responsavel.estado === ''
      );
    }
  },
  methods: {
    maskPhone(tel) {
      tel = tel.replace(/\D/g, '');
      tel = tel.replace(/^(\d)/, '($1');
      tel = tel.replace(/(.{3})(\d)/, '$1)$2');
      if (tel.length == 9) {
        tel = tel.replace(/(.{1})$/, '-$1');
      } else if (tel.length == 10) {
        tel = tel.replace(/(.{2})$/, '-$1');
      } else if (tel.length == 11) {
        tel = tel.replace(/(.{3})$/, '-$1');
      } else if (tel.length == 12) {
        tel = tel.replace(/(.{4})$/, '-$1');
      } else if (tel.length > 12) {
        tel = tel.replace(/(.{4})$/, '-$1');
      }
      if (this.responsavel.telefone !== tel) {
        this.responsavel.telefone = tel;
      }
    },
    validaCampos() {
      if (this.responsavel.nome) {
        this.erro.nome = false;
      }
      if (this.responsavel.estado) {
        this.erro.estado = false;
      }
      if (this.responsavel.email) {
        this.erro.email = false;
      }
      if (this.responsavel.telefone) {
        this.erro.telefone = false;
      }
    },
    salvarUsuario() {
      if (this.invalidForm) {
        this.notifyVue(
          'top',
          'center',
          'danger',
          'Preencha todos os campos corretamente',
          'fa fa-exclamation-triangle'
        );
        return;
      }
      const loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourMethodName,
        color: '#049F0C',
        loader: 'spinner',
        width: 64,
        height: 64,
        backgroundColor: '#ffffff',
        opacity: 0.5,
        zIndex: 999
      });

      const sucessCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Salvo com Sucesso.',
          'fa fa-check'
        );
        this.afterCreateAction();
        this.close();
        loader.hide();
      };

      const errorCallback = err => {
        const message =
          _.get(err, 'response.status') === 400 &&
          _.has(err, 'response.data.message')
            ? _.get(err, 'response.data.message')
            : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

        this.notifyVue(
          'top',
          'center',
          'danger',
          message,
          'fa fa-exclamation-triangle'
        );
        loader.hide();
      };

      let resposavelToSave;
      try {
        resposavelToSave = this.preProcessingResponsavel();
      } catch (e) {
        errorCallback('Dados incorretos');
        return;
      }
      if (resposavelToSave._id) {
        ResponsavelService.atualizar(resposavelToSave)
          .then(sucessCallback)
          .catch(errorCallback);
      } else {
        ResponsavelService.salvar(resposavelToSave)
          .then(sucessCallback)
          .catch(errorCallback);
      }
    },
    preProcessingResponsavel() {
      const regex = /[^0-9]/g;
      let responsavelPreProcessed = { ...this.responsavel };
      responsavelPreProcessed.telefone = responsavelPreProcessed.telefone.replace(
        regex,
        ''
      );
      return responsavelPreProcessed;
    },
    close() {
      this.$emit('close');
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    uploadImage() {
      // eslint-disable-next-line no-undef
      const myWidget = cloudinary.createUploadWidget(
        {
          cloudName: 'dy8mstmqs',
          uploadPreset: 'afqwmioy',
          sources: ['local'],
          multiple: false,
          maxFiles: 1,
          apiKey: '456183971343259'
        },
        (error, result) => {
          if (!error && result && result.event === 'success') {
            this.responsavel.imagem = result.info.url;
            this.validaCampos();
            let nome = this.responsavel.nome;
            this.responsavel.nome = nome + ' ';
            this.responsavel.nome = nome;
          }
        }
      );
      myWidget.open();
    },
    deleteImage() {
      this.responsavel.imagem = '';
      let nome = this.responsavel.nome;
      this.responsavel.nome = nome + ' ';
      this.responsavel.nome = nome;
    }
  },
  watch: {
    'responsavel.telefone': function(newValue) {
      this.maskPhone(newValue);
    }
  }
};
</script>
<style>
.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-body {
  position: relative;
}

#profile-photo {
  width: 7em;
  height: 7em;
}

#upload_widget {
  max-height: 30px;
}
</style>
